import gql from "graphql-tag";

export const topMerchantsList = gql`
  query topMerchantsList(
    $from: String
    $to: String
    $offset: Int
    $limit: Int
  ) {
    fraud {
      merchants_by_volume(
        from: $from
        to: $to
        offset: $offset
        limit: $limit
      ) {
        average_tx
        highest_tx
        name
        transactions
        volume
        merchant {
          name
          id
          snapmin_url
          merchant_limit_configuration {
            name
          }
        }
      }
    }
  }
`;
